import React from "react";
import { withTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { clearRedirectUri } from "../../routes/redirectStorage";
import { purgeOidcState, clearSigninRetry } from "../../utils/oidcStorage";

const styles = {
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        padding: "16px"
    },
    paper: {
        maxWidth: "480px",
        padding: "32px",
        textAlign: "center"
    },
    body: {
        marginBottom: "24px"
    }
};

// Shown when the signin callback could not be completed. Without this page /error
// matched no route at all, which left the user on a blank screen with no way back
// into the app but retyping the address.
export class LoginErrorPage extends React.Component {

    // Full reload rather than a route change: the store still holds the failed
    // session, and the point of the button is to start over from a clean slate.
    handleRetry = () => {
        purgeOidcState();
        clearRedirectUri();
        clearSigninRetry();
        window.location.assign("/");
    }

    render() {
        const { t } = this.props;
        return (
            <div style={styles.container}>
                <Paper style={styles.paper}>
                    <Typography variant="h6" gutterBottom>
                        {t("LoginFailedTitle")}
                    </Typography>
                    <Typography variant="body1" style={styles.body}>
                        {t("LoginFailedHelp")}
                    </Typography>
                    <Button
                        id="login-error-retry"
                        variant="contained"
                        color="primary"
                        onClick={this.handleRetry}>
                        {t("LoginAgain")}
                    </Button>
                </Paper>
            </div>
        );
    }
}

export default withTranslation('common')(LoginErrorPage);
